// style.js
import { styled } from '@mui/material/styles';
import { default as LinkComponent } from 'components/Link';
import { NavLink } from 'react-router-dom';

/* Custom link wrapper */
export const Link = styled(LinkComponent)(({ theme }) => ({
  boxSizing: 'border-box',
  color: 'inherit',
  fontSize: theme.fontSize.large,

  '&.active': {
    borderBottom: '1px solid',
    borderTop: '1px solid transparent'
  }
}));

Link.defaultProps = {
  component: NavLink
};

/* Sticky header */
export const Header = styled('header')(({ theme }) => ({
  alignItems: 'center',
  background: theme.color.primary.main,
  boxSizing: 'border-box',
  color: theme.color.primary.contrast,
  display: 'flex',
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1.625),
  position: 'sticky',
  top: 0,
  zIndex: theme.layer.above
}));
